import { Permission, UserProfile } from '@core/auth/models/auth.models'
import { COMMON_AUTH_PERMISSIONS, COMMON_PERMISSIONS } from '../constants/auth.constants'
import { urlDeepLength } from '@core/utils/main.utils'
import { IAuthConfig } from 'ionic-appauth'
import { IdentityServerConfig } from '@environments/environment-ids.models'
import { RouteUrl } from '@core/enums/routing.enums'

export const parseProfile = (profile: UserProfile): UserProfile => ({
  ...profile,
  permissions: getPermissions(),
  fullName: `${profile.name} ${profile.surname}`,
  favourites: {
    competitionId: profile.favouriteCompetitionId,
    teamId: profile.favouriteTeamId
  }
})

export const getPermissions = (): Permission[] =>
  Array.from(new Set([...COMMON_AUTH_PERMISSIONS, ...COMMON_PERMISSIONS])).map((_page) => ({
    regex: new RegExp(`((?!${_page}/))${_page}$`),
    deepLength: urlDeepLength(_page),
    isDefaultRoute: _page === RouteUrl.MainSub
  }))

export const buildIdentityServerSettings = (settings: IdentityServerConfig): IAuthConfig => ({
  server_host: settings.authorityUrl,
  client_id: settings.clientId,
  redirect_url: settings.redirectUri,
  end_session_redirect_url: settings.endSessionRedirectUri,
  scopes: settings.scopes,
  pkce: true
})
